import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
@Component({
  standalone: false,
  selector: "app-shared-loading",
  templateUrl: "./shared-loading.component.html",
  styleUrls: ["./shared-loading.component.scss"],
})
export class SharedLoadingComponent implements OnInit {
  @Input() progress: number | null = null;
  @Input() phaseLabel = "Cargando...";
  @Input() message = "";
  @Input() showRetry = false;

  @Output() readonly retry = new EventEmitter<void>();

  constructor() {}

  get progressValue(): number {
    return Math.max(0, Math.min(100, Math.round(this.progress ?? 0)));
  }

  requestRetry(): void {
    this.retry.emit();
  }

  ngOnInit(): void {}
}
